import { Component, OnInit, OnDestroy } from '@angular/core';
import {OrderService} from "../../shared/services/order.service";
import {Order} from "../../shared/models/order"
import { ShoppingService } from 'app/shared/services/shopping.service';
import { Router } from '@angular/router';
import { AlertService } from 'app/shared/services/alert.service';

@Component({
  selector: 'app-checkout-thankyou',
  templateUrl: './checkout-thankyou.component.html',
  styleUrls: ['./checkout-thankyou.component.css']
})
export class CheckoutThankyouComponent implements OnInit, OnDestroy {

  private _order:Order;
  private _hasLoadedOrder:boolean;
  private _hasFinishedSingleOrderSetup:boolean;

  constructor(
    private orderService:OrderService
    ,private shoppingService:ShoppingService
    ,private router:Router
    ,private alertService:AlertService
  ) { 
    this._hasLoadedOrder = false;
    this._hasFinishedSingleOrderSetup = false;
  }

  ngOnDestroy() {
    if (this.isSingleCheckoutOrder) {
      this.shoppingService.endSingleItemCheckout();
    }
  }

  ngOnInit() {
    this.orderService.getLastOrder().then((order:Order) => {
      this._hasLoadedOrder = true;
      this._order = order;
    })
    .catch((error) =>{
      console.error(error);
      this._hasLoadedOrder = true;
    })

      // TODO: stephen this is very hacky... but we will do it for now until we can re-arrange the assessment integration
    if (this.isSingleCheckoutOrder) {
      let assignmentCompleteAlerts = setInterval(() => {
        if (this.alertService.getAlertCount() <= 0) {
          clearInterval(assignmentCompleteAlerts);
          this._hasFinishedSingleOrderSetup = true;
        } 
      }, 250);
    }
  }

  public get order() {
    return this._order;
  }

  public get isSingleCheckoutOrder() {
    return this.shoppingService.isSingleCheckoutOrder();
  }

  public get hasFinishedSingleOrderSetup() {
    return this._hasFinishedSingleOrderSetup;
  }

  public returnFromOrder() {
    let returnUrl = this.shoppingService.getSingleItemCheckoutReturnUrl();
    this.router.navigateByUrl(returnUrl);
  }

  public get hasLoadedOrder() {
    return this._hasLoadedOrder;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/checkout-thankyou/checkout-thankyou.component.ts